//Dokumetation under https://github.com/jorgegorka/svelte-router
import Stepper from './components/stepper/Stepper.svelte';

// function isLoggedIn(){
//     return true;
// }

const routes = [
  {
    name: '/',
    component: Stepper
  }

]

export { routes }